const fallbackDetails = {
    title: 'Részletes járműadatok',
    bodyType: 'Személyautó',
    condition: 'Megkímélt',
    origin: 'Magyarországi forgalomba helyezés',
    color: 'Metál szürke',
    doors: 5,
    seats: 5,
    firstRegistration: '2020/06',
    inspectionValidUntil: '2026/06',
    documents: 'Érvényes magyar okmányok',
    serviceBook: 'Vezetett szerviztörténet',
    numberOfKeys: '2 db gyári kulcs',
    engineDisplacementCcm: 1598,
    powerKw: 85,
    powerHp: 116,
    torqueNm: 250,
    drivetrain: 'Elsőkerék-hajtás',
    cylinders: 4,
    emissionClass: 'Euro 6',
    environmentalClass: '6',
    combinedConsumption: '5,2 l/100 km',
    cityConsumption: '6,1 l/100 km',
    highwayConsumption: '4,6 l/100 km',
    ownWeightKg: 1320,
    totalWeightKg: 1850,
    trunkCapacityLiter: 380,
    climate: 'Digitális kétzónás klíma',
    upholstery: 'Szövet kárpit',
    equipment: {
        comfort: ['Tempomat', 'Elektromos ablakok elöl-hátul', 'Multifunkciós kormány', 'Állítható kormány'],
        safety: ['ABS', 'ESP', 'Front- és oldallégzsákok', 'ISOFIX rögzítési pontok'],
        multimedia: ['Bluetooth kihangosító', 'USB csatlakozó', 'Fedélzeti számítógép'],
        exterior: ['Könnyűfém felni', 'LED nappali menetfény', 'Fényezett lökhárítók'],
        other: ['Dohányzásmentes utastér', 'Rendszeresen karbantartott'],
    },
};
const carDetailsById = {
    '1': {
        title: 'Toyota Corolla 1.8 Hybrid e-CVT Comfort',
        bodyType: 'Ferdehátú',
        condition: 'Megkímélt, rendszeresen szervizelt',
        origin: 'Magyarországi első forgalomba helyezés',
        color: 'Gyöngyház fehér',
        doors: 5,
        seats: 5,
        firstRegistration: '2020/07',
        inspectionValidUntil: '2026/07',
        documents: 'Érvényes magyar okmányok, törzskönyv rendelkezésre áll',
        serviceBook: 'Vezetett márkaszerviz előélet',
        numberOfKeys: '2 db gyári kulcs',
        engineDisplacementCcm: 1798,
        powerKw: 90,
        powerHp: 122,
        torqueNm: 142,
        drivetrain: 'Elsőkerék-hajtás',
        cylinders: 4,
        emissionClass: 'Euro 6d-TEMP',
        environmentalClass: '6',
        combinedConsumption: '4,5 l/100 km',
        cityConsumption: '3,9 l/100 km',
        highwayConsumption: '5,0 l/100 km',
        ownWeightKg: 1370,
        totalWeightKg: 1835,
        trunkCapacityLiter: 361,
        climate: 'Digitális kétzónás automata klíma',
        upholstery: 'Sötét szövet kárpit',
        equipment: {
            comfort: ['Kulcs nélküli indítás', 'Tempomat', 'Elektromos ablakok elöl-hátul', 'Multifunkciós bőrkormány'],
            safety: ['Toyota Safety Sense', 'Sávtartó asszisztens', 'Táblafelismerő', 'Adaptív tempomat', 'Tolatókamera'],
            multimedia: ['Érintőkijelzős multimédia', 'Bluetooth', 'Apple CarPlay', 'Android Auto', 'USB csatlakozó'],
            exterior: ['LED fényszóró', 'LED nappali menetfény', 'Könnyűfém felni', 'Elektromosan állítható tükrök'],
            other: ['Dohányzásmentes', 'Alacsony fogyasztású hibrid hajtás', 'Frissen átvizsgálva'],
        },
    },
    '2': {
        title: 'Volkswagen Golf 1.6 TDI Comfortline',
        bodyType: 'Ferdehátú',
        condition: 'Normál használati nyomokkal, jó műszaki állapotban',
        origin: 'EU-s eredet, magyar okmányokkal',
        color: 'Indium szürke metál',
        doors: 5,
        seats: 5,
        firstRegistration: '2019/04',
        inspectionValidUntil: '2026/04',
        documents: 'Érvényes magyar forgalmi, törzskönyv rendelkezésre áll',
        serviceBook: 'Digitális szerviztörténet',
        numberOfKeys: '2 db kulcs',
        engineDisplacementCcm: 1598,
        powerKw: 85,
        powerHp: 115,
        torqueNm: 250,
        drivetrain: 'Elsőkerék-hajtás',
        cylinders: 4,
        emissionClass: 'Euro 6',
        environmentalClass: '6',
        combinedConsumption: '4,3 l/100 km',
        cityConsumption: '5,1 l/100 km',
        highwayConsumption: '3,8 l/100 km',
        ownWeightKg: 1295,
        totalWeightKg: 1850,
        trunkCapacityLiter: 380,
        climate: 'Digitális kétzónás Climatronic',
        upholstery: 'Sötét szövet kárpit',
        equipment: {
            comfort: ['Tempomat', 'Esőérzékelő', 'Automata fényszórókapcsolás', 'Elektromos ablakok elöl-hátul'],
            safety: ['Front Assist', 'Fáradtságérzékelő', 'ABS', 'ESP', 'ISOFIX'],
            multimedia: ['Composition Media', 'Bluetooth', 'USB', 'Fedélzeti számítógép'],
            exterior: ['Könnyűfém felni', 'LED nappali menetfény', 'Fűthető külső tükrök'],
            other: ['Gazdaságos dízelmotor', 'Nagy csomagtér', 'Rendezett belső tér'],
        },
    },
    '3': {
        title: 'BMW 320d Steptronic Advantage',
        bodyType: 'Limousine',
        condition: 'Prémium állapot, garázsban tartott',
        origin: 'Magyarországi első forgalomba helyezés',
        color: 'Black Sapphire metál',
        doors: 4,
        seats: 5,
        firstRegistration: '2021/09',
        inspectionValidUntil: '2027/09',
        documents: 'Érvényes magyar okmányok, törzskönyv rendelkezésre áll',
        serviceBook: 'BMW digitális szervizkönyv',
        numberOfKeys: '2 db gyári kulcs',
        engineDisplacementCcm: 1995,
        powerKw: 140,
        powerHp: 190,
        torqueNm: 400,
        drivetrain: 'Hátsókerék-hajtás',
        cylinders: 4,
        emissionClass: 'Euro 6d',
        environmentalClass: '6',
        combinedConsumption: '4,8 l/100 km',
        cityConsumption: '5,8 l/100 km',
        highwayConsumption: '4,2 l/100 km',
        ownWeightKg: 1545,
        totalWeightKg: 2085,
        trunkCapacityLiter: 480,
        climate: 'Háromzónás automata klíma',
        upholstery: 'Fekete Sensatec kárpit',
        equipment: {
            comfort: ['Elektromos ülésállítás', 'Ülésfűtés elöl', 'Tempomat fékfunkcióval', 'Sport bőrkormány'],
            safety: ['Parkolóradar elöl-hátul', 'Tolatókamera', 'Sávelhagyás figyelmeztető', 'LED fényszóró', 'Vészfék asszisztens'],
            multimedia: ['BMW Live Cockpit', 'Navigáció', 'Bluetooth', 'Apple CarPlay', 'Digitális műszeregység'],
            exterior: ['17 colos könnyűfém felni', 'LED hátsó lámpa', 'Elektromosan behajtható tükrök'],
            other: ['Prémium vezetési élmény', 'Alacsony futásteljesítmény', 'Frissen szervizelve'],
        },
    },
    '4': {
        title: 'Suzuki Vitara 1.6 GL+',
        bodyType: 'Városi terepjáró / SUV',
        condition: 'Jó állapot, normál használati nyomokkal',
        origin: 'Magyarországi első forgalomba helyezés',
        color: 'Galactic Gray metál',
        doors: 5,
        seats: 5,
        firstRegistration: '2018/05',
        inspectionValidUntil: '2026/05',
        documents: 'Érvényes magyar okmányok',
        serviceBook: 'Részben vezetett szervizkönyv, számlákkal igazolt karbantartás',
        numberOfKeys: '2 db kulcs',
        engineDisplacementCcm: 1586,
        powerKw: 88,
        powerHp: 120,
        torqueNm: 156,
        drivetrain: 'Elsőkerék-hajtás',
        cylinders: 4,
        emissionClass: 'Euro 6',
        environmentalClass: '6',
        combinedConsumption: '5,7 l/100 km',
        cityConsumption: '6,8 l/100 km',
        highwayConsumption: '5,0 l/100 km',
        ownWeightKg: 1075,
        totalWeightKg: 1730,
        trunkCapacityLiter: 375,
        climate: 'Automata klíma',
        upholstery: 'Szövet kárpit',
        equipment: {
            comfort: ['Tempomat', 'Ülésfűtés elöl', 'Elektromos ablakok', 'Multifunkciós kormány'],
            safety: ['ABS', 'ESP', 'Lejtmenetvezérlő', 'ISOFIX', 'Tolatókamera'],
            multimedia: ['Érintőkijelző', 'Bluetooth', 'USB', 'Navigáció előkészítés'],
            exterior: ['Könnyűfém felni', 'Tetősín', 'LED nappali menetfény', 'Fűthető tükrök'],
            other: ['Megbízható szívó benzinmotor', 'Magas üléspozíció', 'Kedvező fenntartás'],
        },
    },
};
const cloneDetails = (details) => ({
    ...details,
    equipment: {
        comfort: [...details.equipment.comfort],
        safety: [...details.equipment.safety],
        multimedia: [...details.equipment.multimedia],
        exterior: [...details.equipment.exterior],
        other: [...details.equipment.other],
    },
});
const findTemplate = (car) => {
    if (car?.id && carDetailsById[car.id])
        return carDetailsById[car.id];
    const model = `${car?.marka ?? ''} ${car?.modell ?? ''}`.toLowerCase();
    if (model.includes('toyota') && model.includes('corolla'))
        return carDetailsById['1'];
    if (model.includes('volkswagen') && model.includes('golf'))
        return carDetailsById['2'];
    if (model.includes('bmw') && model.includes('320'))
        return carDetailsById['3'];
    if (model.includes('suzuki') && model.includes('vitara'))
        return carDetailsById['4'];
    return fallbackDetails;
};
export const createDefaultCarDetails = (car) => cloneDetails(findTemplate(car));
export const normalizeCarDetailedData = (details, car) => {
    const defaults = createDefaultCarDetails(car);
    const hasHa = Boolean(details?.haListing?.sections?.length);
    // HA importnál ne töltögessünk kitalált fallback mezőket az üres értékek helyére
    if (hasHa) {
        return {
            ...defaults,
            ...details,
            equipment: {
                comfort: details?.equipment?.comfort ?? [],
                safety: details?.equipment?.safety ?? [],
                multimedia: details?.equipment?.multimedia ?? [],
                exterior: details?.equipment?.exterior ?? [],
                other: details?.equipment?.other ?? [],
            },
            haListing: details?.haListing,
        };
    }
    return {
        ...defaults,
        ...details,
        equipment: {
            comfort: details?.equipment?.comfort ?? defaults.equipment.comfort,
            safety: details?.equipment?.safety ?? defaults.equipment.safety,
            multimedia: details?.equipment?.multimedia ?? defaults.equipment.multimedia,
            exterior: details?.equipment?.exterior ?? defaults.equipment.exterior,
            other: details?.equipment?.other ?? defaults.equipment.other,
        },
    };
};
